import React from 'react'
import noop from 'lodash-es/noop'

interface FlatListProps<T> {
  items: T[]
  itemRenderer: (item: T, i: number) => JSX.Element
}

class FlatList<T> extends React.Component<FlatListProps<T>, {}> {
  static get defaultProps() {
    return {
      items: [],
      itemRenderer: noop
    }
  }

  render() {
    const { items, itemRenderer } = this.props

    return (
      <div>
        {items.map(itemRenderer)}
      </div>
    )
  }
}

export default FlatList
